import React from 'react';
import PropTypes from 'prop-types';
import { DarkScreenMask } from '../../..';

import close from '../../../assets/imgs/icon-close.svg';
import "./SwitchClubModal.scss";

const SwitchClubModal = ({ isVisible, clubs, onClose, onSelect })=> {
  const handleSelect = club => {
    onSelect(club);
    onClose();
  };

  return (
    <DarkScreenMask isVisible={isVisible}>
      <div className="switch-club-modal">
        <div className="switch-club-modal__close-icon-container">
          <button type="button" onClick={onClose}>
            <img src={close} alt=""/>
          </button>
        </div>
        <div className="switch-club-modal__clubs">
          {clubs.map(club => 
            <button key={club._id} type="button" className="switch-club-modal__clubs__single-club" onClick={()=> handleSelect(club)}>
              <img className="switch-club-modal__clubs__single-club__image" src={club.logo} alt=""/>
              <span>{club.name}</span>
            </button>
          )}
        </div>
      </div>
    </DarkScreenMask>
  );
};

SwitchClubModal.propTypes = {
  clubs: PropTypes.array, 
  isVisible: PropTypes.bool, 
  onClose: PropTypes.func, 
  onSelect: PropTypes.func
};

SwitchClubModal.defaultProps = {
  clubs: [], 
  isVisible: false, 
  onClose: ()=> {}, 
  onSelect: ()=> {}
};

export default SwitchClubModal;